import React, {createContext, useReducer} from 'react'
import {AutoLoaderDeviceOverviewReducer} from "../reducer/AutoLoaderDeviceOverviewReducer";

export const AutoLoaderDeviceOverviewContext = createContext();

const AutoLoaderOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        autoLoaderDeviceInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(AutoLoaderDeviceOverviewReducer, data)
    return (
        <AutoLoaderDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </AutoLoaderDeviceOverviewContext.Provider>
    )
}
export default AutoLoaderOverviewContextProvider


// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoloader/context/AutoLoaderDeviceOverviewContext.js